import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    events: [],
    pageSize: 0,
    count: '',
    next: '',
    newCount: 0,
    errors: {}
};

getters['fetchEvents'] = function (state) { return state.events }
getters['fetchEventsNext'] = function (state) { return state.next }
getters['fetchEventsPageSize'] = function (state) { return state.pageSize }
getters['fetchEventsNewCount'] = function (state) { return state.newCount }

const actions = {
    get(context) {
        return ApiService
            .get('events/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_NEW_COUNT', response.data.results);
                context.commit('SET_EVENTS', response.data.results);
                context.commit('SET_PAGE_SIZE', response.data.page_size);
                context.commit('SET_NEXT', [
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param,
                ]);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_NEW_COUNT', response.data.results);
                context.commit('ADD_EVENTS', response.data.results);
                context.commit('SET_NEXT', [
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param
                ]);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    addNewFromFront(context, payload) {
        context.commit('ADD_NEW', payload);
    },
    setFriendAccepted(context, payload) {
        context.commit('SET_FRIEND_ACCEPTED', payload);
    },
    setGiftActivated(context, payload) {
        context.commit('SET_GIFT_ACTIVATED', payload);
    },
    remove(context, payload) {
        return ApiService
            .delete('events/remove/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('REMOVE_EVENT', payload);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    clear(context) {
        return ApiService
            .delete('events/clear/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_EVENTS', response.data);
                context.commit('SET_NEXT', '');
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    }
};

const mutations = {
    SET_EVENTS(state, events) {
        state.events = events;
        state.errors = {};
    },
    ADD_EVENTS(state, events) {
        state.events = state.events.concat(events);
        state.errors = {};
    },
    ADD_NEW(state, event) {
        state.events.unshift(event);
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_NEW_COUNT(state, events) {
        state.newCount = 0;
        const cloneEvents = events.slice();
        for (let i in cloneEvents) {
            if (cloneEvents[i].viewed === false) {
                state.newCount++;
            }
        }
    },
    SET_PAGE_SIZE(state, pageSize) {
        state.pageSize = pageSize;
    },
    SET_NEXT(state, [page, num_pages, url, page_param]) {
        if (page < num_pages) {
            state.next =
                url +
                '?' +
                page_param +
                '=' +
                (page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_FRIEND_ACCEPTED(state, id) {
        for (let i in state.events) {
            if (state.events[i].user.id == id) {
                state.events[i].user.is_friend.type = 2;
                state.events[i].extra = false;
            }
        }
    },
    SET_GIFT_ACTIVATED(state, id) {
        for (let i in state.events) {
            if (state.events[i].id == id) {
                state.events[i].extra.activated = true;
            }
        }
    },
    REMOVE_EVENT(state, id) {
        for (let i in state.events) {
            if (state.events[i].id == id) {
                state.events.splice(i, 1);
            }
        }
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
